module.exports = "/images/close.svg?b911e021dfc767feeb29d81eb80a8fb6";